import React, { useRef, useState } from "react"
import { useMsal } from "@azure/msal-react";

import { Box } from "@mui/material";  
import{ type Treshold} from "./rheoadviseConfig";
import { Skid } from "../AvailableSkids/skidsWithConfigProvider";
import { authenticatedFetch } from "../../Helper/Fetch/fetch";
import { loginRequest, protectedResources } from "../../authConfig";
import { getRheoServerUrl } from "../../Config/config";



interface TresholdProps{
    setTreshold: (treshold: Treshold) => void,
    skid:string,
    skidsWithConfig: Map<string, Skid>,
}



function TresholdConfigAdd(props:TresholdProps){
    const { instance, inProgress,accounts } = useMsal();
    const request = {scopes: protectedResources.whoami.scopes,account: accounts[0]}
    const { setTreshold, skid, skidsWithConfig } = props
    const [tag, setTag] = useState<string>('')
    const [type, setType] = useState<string>('delta')
    const [value, setValue] = useState<number>(0)
    const [period, setPeriod] = useState<number>(0)
    const [ratio, setRatio] = useState<number>(0)
    const wraperStyle = {display:'flex'}
    function AddTreshold(newTreshold: Partial<Treshold>,skidName:string, setTreshold: (treshold: Treshold) => void){
        console.log('pushing new treshold')
        newTreshold.Id = PutTreshold(newTreshold, skidName).toString()
        setTreshold(newTreshold as Treshold)
    }
    function setTypeHandler(newType:string){
        console.log('setting type to:',newType)
        setType(newType)
    }
    function minutesToNanoSeconds(minutes:number):number{
        return minutes * 60000000000
    }
    function PutTreshold(newTreshold: Partial<Treshold>,skidName:string):number{
        console.log('pushing new treshold')
        const urlBase = getRheoServerUrl()
        const url = urlBase+'/rheoadvise'
        const params =  new URLSearchParams({
            'Action':'addTreshold',
            'Skid':skidName,
            'Tag':newTreshold.Tag,
            'Type': newTreshold.Type,
            'Value': newTreshold.Value? newTreshold.Value.toString() : '0',
            'Period': newTreshold.Period? newTreshold.Period.toString() : '0',
            'Ratio': newTreshold.Ratio? newTreshold.Ratio.toString() : '0',
        })
        authenticatedFetch(request, instance, params, url).
        then((res)=>{
        if(res.ok){
            alert('Treshold added successfully:'+res.statusText)
            res.json().then((data)=>{
                console.log('response data:',data)
                if(data && data.id){
                    newTreshold.Id = data.id
                    newTreshold.Period = minutesToNanoSeconds(newTreshold.Period)
                    setTreshold(newTreshold as Treshold)
                }else{
                    console.error('No Id returned from backend for new treshold')
                }
            return -1 //placeholder id, since we dont get the new id back from the backend, we just want to trigger a refetch of tresholds in the parent component
        
            })
        }else{
            alert('Error adding treshold:'+res.statusText)
            return -1
        }
    })
    return -1 //placeholder return value, since the real return value is in the promise above
}

    return(
        <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-between', columnGap:5, background:'#0A1929', alignItems:'center' , p:1, borderRadius:2}}>
            <div style={wraperStyle}>
                <p style={{color:'whitesmoke'}} color="white" >Tag: </p>
            <select style={{maxWidth: '120px'}} value={tag} onChange={(e)=>setTag(e.target.value)}>
                <option value="a_api_3rpm_e">a_api_3rpm_e</option>
                <option value="a_api_6rpm_e">a_api_6rpm_e</option>
                <option value="a_3rpm_e">a_3rpm_e</option>
                <option value="a_6rpm_e">a_6rpm_e</option>
            </select>
            </div>
            <div style={wraperStyle}>
            <p style={{color:'whitesmoke'}} color="white" >Type: </p>
            <select style={{maxWidth: '100px'}} value={type} onChange={(e)=>setTypeHandler(e.target.value)}>
                <option value="delta">delta</option>
                <option value="percentage">percentage</option>
            </select>
            </div>
            <div style={wraperStyle}>
                <p style={{color:'whitesmoke'}} color="white" >Value: </p>
                <input style={{maxWidth: '50px', maxHeight:'22px'}} type='number' placeholder="Value" value={value} onChange={(e)=>setValue(parseFloat(e.target.value) || 0)}/> 
            </div>
                <div style={wraperStyle}><p style={{color:'whitesmoke'}} color="white" >Period:</p>
                <input style={{maxWidth: '50px', maxHeight:'22px'}} type='number' placeholder="Period" value={period} onChange={(e)=>setPeriod(parseFloat(e.target.value) || 0)}/>
            </div>
            <div style={wraperStyle}> 
                <p style={{color:'whitesmoke'}} color="white" >Ratio: </p>
                <input style={{maxWidth: '50px', maxHeight:'22px'}} type='number' placeholder="Ratio" value={ratio} onChange={(e)=>setRatio(parseFloat(e.target.value) || 0)}/>
                <p style={{color:'whitesmoke'}} color="white" >%</p>
            </div>
            <button onClick={()=>AddTreshold({ Tag:tag, Type:type, Value:value, Period:period, Ratio:ratio },skidsWithConfig.get(skid).name ,setTreshold)}>Add</button>
        </Box>
    )
}
export default TresholdConfigAdd